enum AgentsTypes {
    GET_AGENTS = 'GET_AGENTS',
    SHOW_AGENTS = 'SHOW_AGENTS',
    SET_AGENTS_ERROR = 'SET_AGENTS_ERROR',
    SET_AGENTS_LOADING = 'SET_AGENTS_LOADING',
    CLEAR_AGENTS = 'CLEAR_AGENTS',
    FILTER_AGENTS = 'FILTER_AGENTS',
}

export default AgentsTypes;
